// eslint-disable-next-line react/prop-types
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import UserRoles from '../../../constants/userRoles';

import SubHeader from '../../Header/SubHeader';
import TeamAlertsSearch from './component/SearchTab/TeamAlertsSearch';
import TeamAlertsSubscription from './component/SubscriptionTab/TeamAlertsSubscription';

const menuOptions = [
  {
    index: 0,
    label: 'Search',
  },
  {
    index: 1,
    label: 'Subscription',
  },
]
const tabName = {
  subscription: 'Subscription'
}

const TeamAlerts = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.User);
  const [selectedOptionMenu, setSelectedOptionMenu] = useState('');

  const handleSelected = (choise) => {
    setSelectedOptionMenu(choise.label);
  }
  console.log('TeamAlerts.jsx: Current User Role:', user.Role);
  if (!([UserRoles.WFM, UserRoles['G&A']].includes(user.Role)) && user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner) {
    console.log('TeamAlerts.jsx: User does not have Admin access and .');
    return navigate(
      '/AccessDenied'
    );
  }

  let TeamAlertsComponent = <TeamAlertsSearch />;
  if (selectedOptionMenu === tabName.subscription) {
    TeamAlertsComponent = <TeamAlertsSubscription />;
  }

  return (
    <>
      <SubHeader
        handleSelected={handleSelected}
        options={menuOptions}
        selectedOptions={selectedOptionMenu}
      />
      {TeamAlertsComponent}
    </>
  );
}

export default TeamAlerts